import { type FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl, defineMessages } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { IMAGE_URL } from '../../constants.ts';
import { getSrcSetString } from '../../../utils/srcStringHelpers.ts';

import styles from './questionListTop.scss';
import dibsCss from 'dibs-css';

const copy = defineMessages({
    imageCaption: {
        id: 'questionsAnswers.imageCaption',
        defaultMessage: 'Interior by Jamie Bush + Co. | Photography by Stephen Johnson',
    },
});

export const QuestionListTop: FC = () => {
    const intl = useIntl();
    return (
        <div className={styles.wrapper}>
            <div className={styles.textWrapper}>
                <h1 className={classNames(dibsCss.m0, styles.header)} data-tn="questions-answers">
                    <FormattedMessage
                        id="questionsAnswers.header"
                        defaultMessage="Questions & Answers"
                    />
                </h1>
                <HeadingLevel>
                    {Heading => (
                        <Heading className={classNames(dibsCss.m0, styles.subHeader)}>
                            <FormattedMessage
                                id="questionsAnswers.subHeader"
                                defaultMessage="Our trusted network of 1stDibs sellers answer common questions"
                            />
                        </Heading>
                    )}
                </HeadingLevel>
            </div>
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={IMAGE_URL}
                    alt={intl.formatMessage(copy.imageCaption)}
                    srcSet={getSrcSetString({
                        url: IMAGE_URL,
                        quality: 80,
                    })}
                />
            </div>
            <div className={styles.imageCaption}>{intl.formatMessage(copy.imageCaption)}</div>
        </div>
    );
};
